import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiBell, FiMenu } from 'react-icons/fi';
import API from '../../api/axios';

const Header = ({ onMenuToggle }) => {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await API.get('/notifications');
        setUnreadCount(res.data.data.unreadCount);
      } catch {
        // silently fail
      }
    };
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const getPageTitle = () => {
    const path = window.location.pathname;
    if (path.includes('/admin/users')) return 'Gestion des utilisateurs';
    if (path.includes('/admin/invoices')) return 'Gestion des factures';
    if (path.includes('/admin/payments')) return 'Suivi des paiements';
    if (path.includes('/admin/transactions')) return 'Transactions';
    if (path.includes('/admin')) return 'Tableau de bord';
    if (path.includes('/patient/invoices')) return 'Mes factures';
    if (path.includes('/patient/payments')) return 'Historique des paiements';
    if (path.includes('/patient/pay')) return 'Paiement';
    if (path.includes('/patient')) return 'Tableau de bord';
    return 'NomargueriPay';
  };

  return (
    <header className="header">
      <div className="header-title">
        <button className="menu-toggle" onClick={onMenuToggle} aria-label="Menu">
          <FiMenu size={22} />
        </button>
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="header-actions">
        <div style={{ position: 'relative', cursor: 'pointer' }}>
          <FiBell size={20} color="var(--gray-600)" />
          {unreadCount > 0 && (
            <span style={{
              position: 'absolute', top: -6, right: -6,
              background: 'var(--danger)', color: 'white',
              borderRadius: '50%', width: 18, height: 18,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, fontWeight: 700,
            }}>
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </div>
        <span style={{ fontSize: 14, color: 'var(--gray-600)' }}>
          {user?.first_name} {user?.last_name}
        </span>
      </div>
    </header>
  );
};

export default Header;
